
import './App.scss';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/scss/style.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {BrowserRouter,Routes, Route} from 'react-router-dom'
import SharedLayout from './components/SharedLayout';
import Login from './components/Login';
import Products from './components/Products';
import Loginprotectedroute from './components/Loginprotectedroute';
import Register from './components/Register';
import Cart from './components/Cart';
import ProtectedRoute from './components/ProtectedRoute';
import Orderform from './components/Orderform';
import Orders from './components/Orders';
import Shop from './components/shop/Shop';
import Details from './components/productdetail/Details';
import Branditems from './components/shopbybrand/Branditems';
import Profile from './components/profile/Profile';
import Userdata from './components/profile/Userdata';
import Userorder from './components/profile/Userorder';
import Forgotpassword from './components/Forgotpassword';
function App() {
  return (
    <div>
  <BrowserRouter>
    <Routes>
      <Route path='/' element={  <SharedLayout />   }>
        <Route index element={<ProtectedRoute> <Products />  </ProtectedRoute>   } />
        <Route path='login' element={<Loginprotectedroute>  <Login /> </Loginprotectedroute>} />
        <Route path='forgotpassword' element={<Loginprotectedroute>  <Forgotpassword /> </Loginprotectedroute>} />
        <Route path='register' element={<Loginprotectedroute> <Register /> </Loginprotectedroute> } />
        <Route path='cart' element={ <ProtectedRoute>  <Cart/> </ProtectedRoute>   } />
        <Route path='orderform' element={<ProtectedRoute>  <Orderform /> </ProtectedRoute>  } />
        <Route path='orders' element={<ProtectedRoute> <Orders /> </ProtectedRoute>  } />
        <Route path='Shop' element={<ProtectedRoute> <Shop /> </ProtectedRoute> } />
        <Route path='/Profile' element={<ProtectedRoute>  <Profile /> </ProtectedRoute>} >
        <Route index path='/Profile' element={<ProtectedRoute>  <Userdata /> </ProtectedRoute>} />
        <Route path='userorders' element={<ProtectedRoute>  <Userorder /> </ProtectedRoute>} />
        </Route>
        <Route path="/prod/:id" element={<ProtectedRoute>  <Details /> </ProtectedRoute> } />
        <Route path="/brand" element={<ProtectedRoute>  <Branditems /> </ProtectedRoute> } />
        <Route path='*' element={<div className='text-center text-drak mt-5'>Error Page Not Found</div>} />
     </Route> 
     </Routes>
  </BrowserRouter>
    </div>
  );
}

export default App;
